import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Subject, tap } from 'rxjs';
import { environment } from 'environments/environment';

/** Notifications only: the BE owns validation and its latest persisted result. */
@Injectable({ providedIn: 'root' })
export class EventHealthSaveNotifications {
  readonly saved = new Subject<string>();
}

export const eventHealthSaveInterceptor: HttpInterceptorFn = (request, next) => {
  const notifications = inject(EventHealthSaveNotifications);
  const base = environment.apiUrl.replace(/\/$/, '') + '/';
  const relative = request.url.startsWith(base) ? request.url.slice(base.length).split('?')[0] : '';
  // Limit notifications to event writes, excluding uploads, deletes and health requests.
  const eventWrite = /^(?:ctes\/(?:aggregation|disaggregation|commingling|storing|fishing|farmharvest|shipping|processing|on-vessel-processing|first-landing|receive|feed-mill|hatching|transporting|transshipment)|feeding)(?:\/[^/]+)?$/.test(relative)
    && ['POST', 'PUT', 'PATCH'].includes(request.method);
  return next(request).pipe(tap(event => {
    if (!eventWrite || !(event instanceof HttpResponse) || !event.ok) return;
    const body = request.body as { eventID?: string; uid?: string } | null;
    const response = event.body as { eventID?: string; uid?: string } | string | null;
    const uid = body?.eventID || body?.uid || (typeof response === 'string' ? response : response?.eventID || response?.uid);
    if (uid) notifications.saved.next(uid);
  }));
};
